import { useMemo } from 'react';
import { Stack, type StackProps, useTheme, useThemeName } from '@adc/parallax-component-library';
import { AppLogo } from 'Components/utility';
import { useMediaQuery } from 'Hooks';

const MEDIA_QUERY = { maxWidth: 440 };

const Container = ({ children }: React.PropsWithChildren) => {
  const [isMobileBrowser] = useMediaQuery(MEDIA_QUERY);
  const theme = useTheme();
  const themeName = useThemeName();
  // @ts-expect-error Typescript complains on `.val` usage
  const color = theme['surface.container'].val;

  const additionalProps: StackProps = useMemo(
    () =>
      isMobileBrowser
        ? {
            padding: 16,
          }
        : {
            borderRadius: 32,
            padding: 80,
            paddingTop: 48,
            shadow: '$1',
            maxWidth: 560,
          },
    [isMobileBrowser]
  );

  return (
    <>
      {isMobileBrowser && (
        <meta name="theme-color" media={`(prefers-color-scheme: ${themeName})`} content={color} />
      )}
      <Stack
        flexDirection="column"
        backgroundColor={isMobileBrowser ? '$surface.container' : '$surface.background'}
        alignItems="center"
        style={[
          {
            minHeight: window.innerHeight,
            height: '100vh',
          },
        ]}
      >
        <AppLogo isMobileBrowser={isMobileBrowser} />
        <Stack {...additionalProps} backgroundColor="$surface.container" gap="$8" width="100%">
          {children}
        </Stack>
      </Stack>
    </>
  );
};

export { Container };
